import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import list from './list';

const daerah = {
  namespaced: true,

  state() {
    return {
      provinsi: [],
      kabupaten: [],
      kecamatan: [],
      kelurahan: [],
      totalProvinsi: 0,
      totalKabupaten: 0,
      totalKecamatan: 0,
      totalKelurahan: 0,
      totalKodepos: 0,
      kodepos: [],
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
    };
  },

  mutations: {
    setProvinsi(state, provinsi) {
      state.provinsi = provinsi.list;
      state.totalProvinsi = provinsi.countdata;
    },
    setKabupaten(state, kabupaten) {
      state.kabupaten = kabupaten.list;
      state.totalKabupaten = kabupaten.countdata;
    },
    setKecamatan(state, kecamatan) {
      state.kecamatan = kecamatan.list;
      state.totalKecamatan = kecamatan.countdata;
    },
    setKelurahan(state, kelurahan) {
      state.kelurahan = kelurahan.list;
      state.totalKelurahan = kelurahan.countdata;
    },
    setKodepos(state, kodepos) {
      state.kodepos = kodepos.list;
      state.totalKodepos = kodepos.countdata;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    removeProvinsi(state, { index }) {
      state.totalProvinsi -= 1;
      state.provinsi = state.provinsi.filter((value) => value.id_prov != index);
    },

    removeKabupaten(state, { index }) {
      state.totalKabupaten -= 1;
      state.kabupaten = state.kabupaten.filter(
        (value) => value.id_kab != index
      );
    },

    removeKecamatan(state, { index }) {
      state.totalKecamatan -= 1;
      state.kecamatan = state.kecamatan.filter(
        (value) => value.id_kec != index
      );
    },

    removeKelurahan(state, { index }) {
      state.totalKelurahan -= 1;
      state.kelurahan = state.kelurahan.filter(
        (value) => value.id_kel != index
      );
    },

    removeKodepos(state, { index }) {
      state.totalKodepos -= 1;
      state.kodepos = state.kodepos.filter((value) => value.zip_code != index);
    },

    pushProvinsi(state, { payload }) {
      state.provinsi.push(payload);
      state.totalProvinsi += 1;
    },

    pushKabupaten(state, { payload }) {
      state.kabupaten.push(payload);
      state.totalKabupaten += 1;
    },

    pushKecamatan(state, { payload }) {
      state.kecamatan.push(payload);
      state.totalKecamatan += 1;
    },

    pushKelurahan(state, { payload }) {
      state.kelurahan.push(payload);
      state.totalKelurahan += 1;
    },

    pushKodepos(state, { payload }) {
      state.kodepos.push(payload);
      state.totalKodepos += 1;
    },

    editProvinsi(state, { payload, index }) {
      Object.assign(state.provinsi[index], payload);
    },
    editKabupaten(state, { payload, index }) {
      Object.assign(state.kabupaten[index], payload);
    },
    editKecamatan(state, { payload, index }) {
      Object.assign(state.kecamatan[index], payload);
    },
    editKelurahan(state, { payload, index }) {
      Object.assign(state.kelurahan[index], payload);
    },

    editKodepos(state, { payload, index }) {
      Object.assign(state.kodepos[index], payload);
    },
  },

  actions: {
    async fetchAllDaerah(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, category }
    ) {
      ctx.commit('setLoading', true);
      let capitalized = category.charAt(0).toUpperCase() + category.slice(1);
      capitalized = capitalized.replace('-', '');
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      }

      let data;
      switch (category) {
        case 'provinsi':
          data = JSON.stringify({
            search: {
              nama: search.nama,
              id_prov: search.id_prov,
            },
            sort_by,
            limit: itemsPerPage.toString(),
            page: page.toString(),
            version: btoa(
              CryptoJS.SHA256(
                page.toString() +
                  itemsPerPage.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kabupaten':
          data = JSON.stringify({
            search: {
              id_prov: search.id_prov,
              id_kab: '',
              nama_prov: search.nama_prov,
              nama_kab: search.nama_kab,
            },
            sort_by,
            limit: itemsPerPage.toString(),
            page: page.toString(),
            version: btoa(
              CryptoJS.SHA256(
                page.toString() +
                  itemsPerPage.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kecamatan':
          data = JSON.stringify({
            search: {
              id_prov: '',
              id_kab: '',
              id_kec: '',
              nama_prov: '',
              nama_kab: search.nama_kab,
              nama_kec: search.nama_kec,
            },
            sort_by,
            limit: itemsPerPage.toString(),
            page: page.toString(),
            version: btoa(
              CryptoJS.SHA256(
                page.toString() +
                  itemsPerPage.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kelurahan':
          data = JSON.stringify({
            search: {
              id_prov: '',
              id_kab: '',
              id_kec: '',
              id_kel: '',
              nama_prov: search.nama_prov,
              nama_kab: search.nama_kab,
              nama_kec: search.nama_kec,
              nama_kel: search.nama_kel,
            },
            sort_by,
            limit: itemsPerPage.toString(),
            page: page.toString(),
            version: btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kode-pos':
          data = JSON.stringify({
            search: {
              nama: search.namaProvinsi,
              id_prov: search.kodeProvinsi,
            },
            sort_by,
            limit: itemsPerPage.toString(),
            page: page.toString(),
            version: btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                  page.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/index`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      await axios(config)
        .then((response) => {
          if (response.data.code == '200') {
            ctx.commit(`set${capitalized}`, response.data.data);
          }
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },

    async createDaerah(ctx, { date, payload, category }) {
      ctx.commit('setLoading', true);
      let capitalized = category.charAt(0).toUpperCase() + category.slice(1);
      capitalized = capitalized.replace('-', '');

      let data;
      switch (category) {
        case 'provinsi':
          data = JSON.stringify({
            id_prov: payload.id_prov.toString(),
            nama: payload.nama.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_prov.toString() +
                  payload.nama.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kabupaten':
          data = JSON.stringify({
            id_prov: payload.provinsi.id_prov.toString(),
            id_kab: payload.id_kab.toString(),
            nama_kab: payload.nama_kab.toString(),
            nama_kab_15: payload.nama_15.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.provinsi.id_prov.toString() +
                  payload.id_kab.toString() +
                  payload.nama_kab.toString() +
                  payload.nama_15.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kecamatan':
          data = JSON.stringify({
            id_prov: payload.provinsi.id_prov.toString(),
            id_kec: payload.id_kec.toString(),
            id_kab: payload.kabupaten.id_kab.toString(),
            nama_kec: payload.nama_kec.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.provinsi.id_prov.toString() +
                  payload.kabupaten.id_kab.toString() +
                  payload.id_kec.toString() +
                  payload.nama_kec.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kelurahan':
          data = JSON.stringify({
            id_prov: payload.provinsi.id_prov.toString(),
            id_kab: payload.kabupaten.id_kab.toString(),
            id_kec: payload.kecamatan.id_kec.toString(),
            id_kel: payload.id_kel.toString(),
            nama_kel: payload.nama_kel.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.provinsi.id_prov.toString() +
                  payload.kabupaten.id_kab.toString() +
                  payload.kecamatan.id_kec.toString() +
                  payload.id_kel.toString() +
                  payload.nama_kel.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kode-pos':
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/create`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          const newData = response.data.data;
          ctx.commit(`push${capitalized}`, {
            payload: newData,
          });
          return true;
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async updateDaerah(ctx, { date, payload, index, category }) {
      ctx.commit('setLoading', true);
      let capitalized = category.charAt(0).toUpperCase() + category.slice(1);
      capitalized = capitalized.replace('-', '');

      let data;
      switch (category) {
        case 'provinsi':
          data = JSON.stringify({
            id: payload.id.toString(),
            id_prov: payload.id_prov.toString(),
            nama: payload.nama.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_prov.toString() +
                  payload.nama.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kabupaten':
          data = JSON.stringify({
            id: payload.id.toString(),
            id_prov: payload.provinsi.id_prov.toString(),
            id_kab: payload.id_kab.toString(),
            nama_kab: payload.nama_kab.toString(),
            nama_15: payload.nama_15.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id.toString() +
                  payload.provinsi.id_prov.toString() +
                  payload.id_kab.toString() +
                  payload.nama_kab.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kecamatan':
          data = JSON.stringify({
            id: payload.id.toString(),
            id_prov: payload.provinsi.id_prov.toString(),
            id_kab: payload.kabupaten.id_kab.toString(),
            id_kec: payload.id_kec.toString(),
            nama_kec: payload.nama_kec.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id.toString() +
                  payload.provinsi.id_prov.toString() +
                  payload.kabupaten.id_kab.toString() +
                  payload.id_kec.toString() +
                  payload.nama_kec.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kelurahan':
          data = JSON.stringify({
            id: payload.id.toString(),
            id_prov: payload.provinsi.id_prov.toString(),
            id_kab: payload.kabupaten.id_kab.toString(),
            id_kec: payload.kecamatan.id_kec.toString(),
            id_kel: payload.id_kel.toString(),
            nama_kel: payload.nama_kel.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id.toString() +
                  payload.provinsi.id_prov.toString() +
                  payload.kabupaten.id_kab.toString() +
                  payload.kecamatan.id_kec.toString() +
                  payload.id_kel.toString() +
                  payload.nama_kel.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kode-pos':
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/update`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          const updatedData = response.data.data;
          ctx.commit(`edit${capitalized}`, {
            payload: updatedData,
            index,
          });
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async deleteDaerah(ctx, { date, payload, index, category }) {
      ctx.commit('setLoading', true);
      let capitalized = category.charAt(0).toUpperCase() + category.slice(1);
      capitalized = capitalized.replace('-', '');

      let data;
      switch (category) {
        case 'provinsi':
          data = JSON.stringify({
            id_prov: payload.id_prov.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_prov.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kabupaten':
          data = JSON.stringify({
            id_kab: payload.id_kab.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_kab.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kecamatan':
          data = JSON.stringify({
            id_kec: payload.id_kec.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_kec.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kelurahan':
          data = JSON.stringify({
            id_kel: payload.id_kel.toString(),
            version: btoa(
              CryptoJS.SHA256(
                payload.id_kel.toString() +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kode-pos':
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/delete`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          ctx.commit(`remove${capitalized}`, {
            index,
          });
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
    async export(ctx, { date, sortBy, sortDesc, search, category }) {
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      }
      let data;
      switch (category) {
        case 'provinsi':
          data = JSON.stringify({
            sort_by,
            search: {
              id_prov: search.id_prov,
              nama: search.nama,
            },
            version: btoa(
              CryptoJS.SHA256(
                sort_by +
                  date +
                  atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kabupaten':
          break;
        case 'kecamatan':
          break;
        case 'kelurahan':
          break;
        case 'kode-pos':
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/export`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },
  modules: {
    list,
  },
};
export default daerah;
